import { AbstractControl, ControlContainer, FormArray, FormGroup } from '@angular/forms';
import { ValueOf } from './value-of';
import { SkipSelf } from '@angular/core';
import { IdItem } from './models/item';

const resolvedPromise = Promise.resolve(null);

export const CONTROL_CONTAINER_PROVIDER = {
    provide: ControlContainer,
    useFactory: (container: ControlContainer) => container,
    deps: [[new SkipSelf(), ControlContainer]]
};

export function checkValueInList(control: AbstractControl, itens: ValueOf<IdItem>[]): void {
    if (!control) {
        return;
    }

    const value: IdItem | IdItem[] = control.value;
    if (!value || itens == undefined) {
        return;
    }
    if (Array.isArray(value)) {
        // Verifica se os valores selecionados estão presentes na nova lista de itens.
        const set = new Set<IdItem>(itens.map(i => i.valueOf()));
        const newValues = value.filter(v => set.has(v));
        if (newValues.length != value.length) {
            resolvedPromise.then(() => control.setValue(newValues));
        }
    } else {
        for (const item of itens) {
            if (value == item.valueOf()) {
                return;
            }
        }
        clearValue(control);
    }
}

function isString(value: any): value is string {
    return typeof value === 'string' || value instanceof String;
}

function getDefaultValue(value: any): any | null {
    if (isString(value)) {
        return '';
    } else {
        if (Array.isArray(value)) {
            return [];
        }
    }
    return null;
}

export function clearValue(control: AbstractControl): void {
    if (!control) {
        return;
    }
    control.setValue(getDefaultValue(control.value));
}

type ControlsParent = FormGroup | FormArray;

export function touchControlsMarkDirty(form: ControlsParent): void {
    Object.values(form.controls).forEach(control => {
        if ((control as ControlsParent).controls) {
            touchControlsMarkDirty(control as ControlsParent);
        }
        control.markAsTouched({ onlySelf: true });
        if (control.invalid) {
            control.markAsDirty({ onlySelf: true });
        }
    });
}

export function customError(msg: string): { message: string } {
    return { message: msg };
}
